import { useCallback, useEffect } from 'react';
import { useStore } from 'zustand';
import ConversationsDispatcher from '@/widget/application/conversations/ConversationsDispatcher';
import { useChatWidgetContext } from '@/widget/services/useChatWidgetContext';

export default function useConversationsList() {
  const { store } = useChatWidgetContext();
  const subscription = useStore(store, (state) => state.widgetSubscription);
  const contactRecognized = useStore(store, (state) => state.contactRecognized);
  const conversationKeys = useStore(store, (state) => state.conversationKeys);
  const conversations = useStore(store, (state) => state.conversations);
  const conversationsLoaded = useStore(store, (state) => state.conversationsLoaded);
  const { setMode, setActiveConversationKey } = store.getState();

  const openConversation = useCallback((key) => {
    setActiveConversationKey(key);
    setMode('conversation');
  }, [setActiveConversationKey, setMode]);

  useEffect(() => {
    if (!contactRecognized || conversationsLoaded || !subscription) { return; }

    ConversationsDispatcher.requestData({
      subscription,
      conversationKeys,
    });
  }, [contactRecognized, conversationsLoaded, conversationKeys, subscription]);

  return {
    conversations,
    openConversation,
  };
}
